export default __webpack_public_path__ + "static/media/cgi.74d2110d.svg";